import { createReducer, on } from '@ngrx/store';
import { IRecentSurveysState } from '../../state/app.state';
import {
  getIncidents,
  getIncidentsFailure,
  getIncidentsSuccess,
} from './recent-surveys.actions';

export const recentSurveysInitialState: IRecentSurveysState = {
  incidents: [],
  loading: false,
};

export const recentSurveysReducer = createReducer(
  recentSurveysInitialState,
  on(getIncidents, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(getIncidentsSuccess, (state, { incidents }) => {
    return {
      ...state,
      incidents,
      loading: false,
    };
  }),
  on(getIncidentsFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  })
);
